import common from './common.json'
import wriskDriveawayFreeP5D from './schemes/wrisk-driveaway-free-P5D.json'
import wriskFlex from './schemes/wrisk-flex.json'

export default {
  common,
  'wrisk-flex': wriskFlex,
  'wrisk-driveaway-free-P5D': wriskDriveawayFreeP5D,
}
